import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "选择的颜色值",
      type: "String"
    },
    {
      prop: "borderRadius",
      description: "颜色选择器是否圆角",
      type: "Boolean",
      default: false
    }
  ],
  events: [],
  methods: [],
  slots: [
    {
      name: "默认slots",
      description: "颜色选择器插槽"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
